import "../../assets/styles/product-view.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const BreadCrumbs = ({ navItems = [] }) => {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.settings.lang);
  return (
    <div className="container">
      <div className="breadcrumbs">
        <ul className="items">
          <li
            className="item home"
            onClick={(e) => {
              window.location.href = `https://eclear.com/${lang}/`;
            }}
          >
            <a href={`#`} title="Go to Home Page">
              Home{" "}
            </a>
          </li>
          {navItems?.map((item, idx) => {
            return (
              <li className="item " key={idx}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item?.href);
                  }}
                  title={item?.title}
                  style={{
                    cursor: idx < navItems.length - 1 && "pointer",
                    fontFamily: "Theinhardt-Regular",
                  }}
                >
                  {item?.title}{" "}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default BreadCrumbs;
